export default abstract class Parseable {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public static parseFromObject(object: any): Parseable {
        // static abstract methods are not allowed in ts :(
        throw new Error('Overwrite me!!');
    }

    public static parseFromArray(array: any[]): Parseable[] {
        if (!Array.isArray(array)) {
            return [];
        }
        return array.map((obj) => this.parseFromObject(obj));
    }

    public abstract parseToObject(): any;
}
